import React from "react";

import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from "@mui/material";

import { Trans } from "@lingui/macro";
import { SubscriptionTableProps } from "./models";

export class SubscriptionTable extends React.Component<SubscriptionTableProps, {}>
{
	render()
	{
		return (<Table sx={{mt: 10}}>
      <TableBody>
        <TableRow>
          <TableCell sx={{border: 0, width: "200px"}}>
            <Typography variant="h3" sx={{color: "#FFFFFF", fontSize: "20px", textTransform: "uppercase", textAlign: "center", background: process.env.REACT_APP_PRIMARY_COLOR}}><Trans id="st-table-cell-subscription">Abbonamento</Trans></Typography>
          </TableCell>
          <TableCell sx={{border: 0, width: "300px"}}/>
          <TableCell sx={{border: 0, width: "500px"}}>
            <Typography variant="h3" sx={{color: "#FFFFFF"}}><Trans id="st-table-cell-plan">Piano</Trans></Typography>
          </TableCell>
          <TableCell sx={{border: 0}}>
            <Typography variant="body2" sx={{color: "#D9D9D9"}}>{this.props.product?.name}</Typography>
          </TableCell>
        </TableRow>
        <TableRow>
            <TableCell sx={{border: 0, width: "200px"}}/>
            <TableCell sx={{border: 0, width: "300px"}}/>
            <TableCell sx={{border: 0, width: "500px"}}>
              <Typography variant="h3" sx={{color: "#FFFFFF"}}><Trans id="st-table-cell-status">Stato</Trans></Typography>
            </TableCell>
            <TableCell sx={{border: 0}}>
              <Typography variant="body2" sx={{color: "#D9D9D9"}}>{this.props.subscription?.status}</Typography>
            </TableCell>
          </TableRow>
        {!this.props.subscription?.trial_start && <>
          <TableRow>
            <TableCell sx={{border: 0, width: "200px"}}/>
            <TableCell sx={{border: 0, width: "300px"}}/>
            <TableCell sx={{border: 0, width: "500px"}}>
              <Typography variant="h3" sx={{color: "#FFFFFF"}}><Trans id="st-table-cell-start-date">Data di inizio</Trans></Typography>
            </TableCell>
            <TableCell sx={{border: 0}}>
              <Typography variant="body2" sx={{color: "#D9D9D9"}}>{new Date(this.props.subscription?.start_date!*1000).toLocaleDateString("it-IT")}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{border: 0, width: "200px"}}/>
            <TableCell sx={{border: 0, width: "300px"}}/>
            <TableCell sx={{border: 0, width: "500px"}}>
              <Typography variant="h3" sx={{color: "#FFFFFF"}}><Trans id="st-table-cell-end-date">Data di annullamento</Trans></Typography>
            </TableCell>
            <TableCell sx={{border: 0}}>
              <Typography variant="body2" sx={{color: "#D9D9D9"}}>{new Date(this.props.subscription?.cancel_at_period_end? this.props.subscription?.current_period_end*1000 : this.props.subscription?.cancel_at!*1000).toLocaleDateString("it-IT")}</Typography>
            </TableCell>
          </TableRow>
        </>}
        {this.props.subscription?.trial_start && <>
          <TableRow>
            <TableCell sx={{border: 0, width: "200px"}}/>
            <TableCell sx={{border: 0, width: "300px"}}/>
            <TableCell sx={{border: 0, width: "500px"}}>
              <Typography variant="h3" sx={{color: "#FFFFFF"}}><Trans id="st-table-cell-start-trial">Inizio periodo di prova</Trans></Typography>
            </TableCell>
            <TableCell sx={{border: 0}}>
              <Typography variant="body2" sx={{color: "#D9D9D9"}}>{this.props.subscription.trial_start}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{border: 0, width: "200px"}}/>
            <TableCell sx={{border: 0, width: "300px"}}/>
            <TableCell sx={{border: 0, width: "500px"}}>
              <Typography variant="h3" sx={{color: "#FFFFFF"}}><Trans id="st-table-cell-end-trial">Fine periodo di prova</Trans></Typography>
            </TableCell>
            <TableCell sx={{border: 0}}>
              <Typography variant="body2" sx={{color: "#D9D9D9"}}>{this.props.subscription.trial_end}</Typography>
            </TableCell>
          </TableRow>
        </>}
        <TableRow>
          <TableCell sx={{border: 0}}/>
          <TableCell sx={{border: 0}}/>
          <TableCell sx={{border: 0}}>
            <Button variant="contained"
              color={"secondary"}
              size={"small"}
              type="submit"
              onClick={() => (this.props.deleteSubscription())}>
              <Trans id="st-delete-subscription-button">Disdici abbonamento</Trans>
            </Button>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>)
	}
}
